export default {
    "button.create": "Create",
    "button.upload": "Upload",
    "button.cancelEdit": "Cancel editing",
    "button.edit": "Edit",
    "button.restore": "Restore",
    "button.delete": "Delete",
    "button.display_more": "Display more",
    "button.confirm": "Confirm",
    "button.clear": "Clear",
    "button.cancel": "Cancel",
    "button.forgotten_pwd": "Send Password Reset Email",
    "button.back": "Back to previous page",
    "button.reload": "Reload",
    "button.pick": "Pick",

    "tag.location": "Location",
    "tag.ev_schedule": "Schedule",
    "tag.ev_charger": "Ev Charger",
    "tag.play_list": "Play List",
    "tag.report": "Report",
    "tag.setting": "Settings",
    "tag.stakeholders": "Stakeholders",

    "table.select": "select",
    "table.items": "items",
    "table.additional_details": "Additional Details",
    "table.state": "State",
    "table.state_deleted": "Deleted",
    "table.state_existing": "Existing",
    "table.state_all": "All",
    "table.deleted_at": "Deleted At",

    "table.ev_schedule.to_date": "End Date",
    "table.ev_schedule.from_date": "Start date",
    "table.ev_schedule.to_time": "End time",
    "table.ev_schedule.from_time": "Start time",
    "table.ev_schedule.billing_scheme": "Billing Scheme",
    "table.ev_schedule.billing_scheme_kwh": "kwh",
    "table.ev_schedule.billing_scheme_time": "Time",
    "table.ev_schedule.action": "Action",
    "table.ev_schedule.promotion_id": "Id",

    "ev_charger.display_name": "Display Name",
    "ev_charger.serial_number": "Serial Number",
    "ev_charger.voltage": "Voltage",
    "ev_charger.current_type": "Current Type",
    "ev_charger.device_status": "Status",
    "ev_charger.power": "Power",

    "table.transaction.trx_id": "Id",
    "table.transaction.reference_code": "Reference code",

};
